const translations = {
    invitations: 'Invitations',
    sectionDescription:
        'Invite new users, set user permissions, and remove users from your account.',
    title: 'Users',
    users: 'Users'
};

export default translations;
